import React from 'react'
import {createSelectableContext} from "../../hooks/useSignalUpdate";

export const [RecordsProvider,useRecordsSelector] = createSelectableContext()